module.exports = __webpack_public_path__ + "static/media/g3.c043ec37.png";